// 接口配置文件
let api = {};

api.login = '/PILEHOME/api/h5/login';

// 新增
api.pile = {
    add:'PILEHOME/api/h5/pileuser/add',
    pileEdit:'PILEHOME/api/h5/pileuser/edit',
    delete:'PILEHOME/api/h5/pileuser/delete',
    list:'PILEHOME/api/h5/pileuser/list',
    // cmd:'PILEHOME/api/pile/cmd',
    cmd:'PILEHOME/api/h5/cmd',
    checkorder:'PILEHOME/api/h5/chargehistory/checkorder',
    bookchargelist:'PILEHOME/api/h5/bookcharge/list',
    page:'PILEHOME/api/h5/chargehistory/page',
    addPlan:'PILEHOME/api/h5/bookcharge/add',
    editPlan:'PILEHOME/api/h5/bookcharge/edit',
    delPlan:'PILEHOME/api/h5/bookcharge/delete',
    orderNo:'PILEHOME/api/h5/chargehistory/findByNo',
    chargeMonth:'PILEHOME/api/h5/chargehistory/chargeMonth',
};

api.getPileStatus = 'PILEHOME/api/h5/findstatus';
// api.getPileStatus = 'PILEHOME/api/pilestautshistory/findstatus';

// 消息列表
api.msgList = 'PILEHOME/api/h5/fordmsg/page';
api.msgDel = 'PILEHOME/api/h5/fordmsg/delete';

export default api;


// WEBPACK FOOTER //
// ./src/configs/apiConfig.js